var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"owl",staticClass:"owl-carousel owl-theme"},[_vm._t("default")],2)
}]

export { render, staticRenderFns }